import React, { useContext, useEffect, useRef, useState } from "react";
import { connect } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
// Helper functions for making API calls
import {
  axiosPostData,
  postData,
} from "../../../Survey/helpers/fetch_services";
import { ThemeUpdateContext } from "../../../App";

import "../../../assets/css/MobileRatingMainStyles.css";
import "../../../assets/css/MobileRatingCustomStyles.css";
import LoadingOverlay from "react-loading-overlay-ts";
import {
  addDirectorMessage,
  removeAnswer,
  setSurveyTheme,
  clearEditAnswer,
} from "../../../redux/survey/actions";
import {
  collectGridHideQuestions,
  processHiddenQuestionsInHistory,
  restoreUnhiddenQuestionToHistory,
  addNewlyVisibleQuestionsToHistory,
  filterByLocation,
  appendAdditionalQuestions,
  calculatePostEditQuestionIndex,
} from "./helpers/hideQuestionsHelpers";
import { filterQuestionsByScheduleWindows } from "../../../Survey/helpers/surveyHelper";
import {
  normalizeQuestionIndices,
  toQuestionIndex,
} from "../../../Survey/helpers/surveyQuestionVisibility";
import SingleQuestion from "./components/SingleQuestion";
import SingleAnswer from "./components/SignleAnswer";
import TextType from "./components/TextType";
import CheckBoxType from "./components/CheckBoxType";
import FileUploadType from "./components/FileUploadType";
import RadioType from "./components/RadioType";
import RatingType from "./components/RatingType";
import SequenceType from "./components/SequenceType";
import EmojiType from "./components/EmojiType";
import StarRatingType from "./components/StarRatingType";
import { useCookies } from "react-cookie";
import EmployeeType from "./components/EmployeeType";
import ClientConnectDirector from "../ClientConnectDirector";
import ContactForm from "../ContactForm";
import {
  isValidEmployeePhone,
  getPhoneValidationMessage,
  getPhoneCountry,
  formatPhoneAnswerForPayload,
  getPhoneDialCode,
} from "components/common/PhoneNumberInput";
import { getCompanyCountryCode } from "helpers/companyCountryHelper";
import { setServeFirstBrandingHidden } from "helpers/serveFirstBranding";
import { SERVE_FIRST_LOGO_URL } from "../../../constants/branding";
import { getDetails } from "../../../webRatingNew/apiHelpers/frontRating";
import CommentsAndImage from "./components/CommentsAndImage";
import { SyncLoader } from "react-spinners";
import sound2 from "../../../sound/facebook_msnger.mp3";
import NumberType from "./components/NumberType";
import SignatureType from "./components/SignatureType";
import { toast } from "react-toastify";
import moment from "moment";
import InventoryType from "./components/InventoryType";
import "./question.css";
import { useIntl } from "react-intl";
import DropdownType from "./components/DropdownType";
import {
  attemptCloseTabOrRedirect,
  calculateExpirationTime,
} from "../../../Survey/helpers/Utils";
import SupportLang from "../../../Common/SupportLang";
import GridType from "./components/GridType";
import GridSpotType from "./components/GridSpotType";
import {
  savePartialResponseForMobile,
  savePartialResponseOnExit,
} from "../../../Survey/helpers/savePartialSurveyAnswers";
import store from "../../../redux/store";
import {
  CSAT_ERROR_CODES,
  csatErrorCode,
  getCsatToken,
  withCsatToken,
} from "../../../helpers/csatToken";
import { removeEmptyOrNullValuesFromAnswersCopy } from "../../../Survey/helpers/surveyHelper";
import { useIdleTimer } from "react-idle-timer";
import AutoSubmitErrorPopup from "../../../Survey/pages/AutoSubmitErrorPopup";

// Main React component for rendering survey questions
function Question(props) {
  const intl = useIntl();
  // Destructuring props to extract relevant data
  const {
    survey,
    answeres,
    directorMessage,
    survey_without_login,
    setSurveyTheme_,
    removeAnswer_,
    addDirectorMessage_,
    edit_answer,
    clearEditAnswer_,
  } = props;
  // Utilizing Context, Router, and Theme hooks
  const { changeTheme } = useContext(ThemeUpdateContext);
  const history = useHistory();
  const location = useLocation();

  const surveyWithoutLogin =
    location.state !== undefined ? location.state.surveyWithoutLogin : "";
  const visitDate =
    location.state !== undefined ? location.state.visitDate : null;
  const visitTimeIn =
    location.state !== undefined ? location.state.visitTimeIn : null;
  const guest_info =
    location.state !== undefined ? location.state.guest_info : null;

  // State hooks for local state management
  const [loading, setLoading] = useState(true);
  const [empLoading, setEmpLoading] = useState(false);

  // Various states for managing survey questions, types, and navigation
  const [allQuestionsOriginal, setAllQuestionsOriginal] = useState([]);
  const [logo, setLogo] = useState(SERVE_FIRST_LOGO_URL);
  const [currentSurvey, setCurrentSurvey] = useState({});
  const [allQuestions, setAllQuestions] = useState([]);
  const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
  const [cookies, setCookie] = useCookies(["survey"]);
  const [surveyResponseCookie, setSurveyResponseCookie] = useCookies([
    "survey_response",
  ]);
  const [surveyType, setSurveyType] = useState("");

  // Visit Time Out state
  const [selectedTimeOut, setSelectedTimeOut] = useState(null);

  const [contactDetail, setContactDetail] = useState({
    name: null,
    email: null,
    phone: "",
  });
  const defaultContactErrors = {
    name: { error: false, message: "" },
    email: { error: false, message: "" },
    phone: { error: false, message: "" },
    emailOrPhone: { error: false, message: "" },
    emailValid: { error: false, message: "" },
  };
  const [contactDetailErrors, setContactDetailErrors] =
    useState(defaultContactErrors);
  const [showErrorPopup, setShowErrorPopup] = useState({
    title: "",
    message: "",
    errors: [],
    show: false,
  });

  // Function to update contact details
  const updateContactDetails = (e, key) => {
    let { value } = e.target;
    if (key) {
      if (key === "email") {
        if (/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,10}$/i.test(value)) {
          updateContactDetailError("emailValid", true, "");
        } else {
          updateContactDetailError("emailValid", false, "");
        }
      }
      setContactDetail((prev) => ({ ...prev, [key]: value }));
    }
  };

  const [customValues, setCustomValues] = useState([]);
  const updateCustomValues = (value, item) => {
    setCustomValues((prev) => ({ ...prev, [item.fieldKey]: value }));
    // remove from the customValuesErrors
    setCustomValuesErrors((prev) => ({
      ...prev,
      [item.fieldKey]: { error: false, message: "" },
    }));
  };

  // Contact Form State and Logic
  const [showContactForm, setShowContactForm] = useState(false);
  const [contactFormData, setContactFormData] = useState({});
  const [contactFormErrors, setContactFormErrors] = useState({});

  const updateContactFormData = (value, fieldKey) => {
    setContactFormData((prev) => ({ ...prev, [fieldKey]: value }));
    setContactFormErrors((prev) => ({
      ...prev,
      [fieldKey]: { error: false, message: "" },
    }));
  };

  // Helper function to check contact requirement
  const checkContactRequiredFromAnswers = (answersData) => {
    let isContactRequired = false;

    for (let questionId in answersData) {
      const question = allQuestionsOriginal.find((q) => q._id === questionId);

      if (
        question?.questionType === "radio" &&
        answersData[questionId]?.value
      ) {
        const selectedOptionId = answersData[questionId].value;
        const selectedOption = question.options?.find(
          (opt) => opt._id === selectedOptionId,
        );

        if (
          selectedOption?.contact_info_required === true &&
          survey_without_login?.contact_info_required === true
        ) {
          isContactRequired = true;
          break;
        }
      }
    }

    return isContactRequired;
  };

  // Check if contact form is required
  const checkContactInfoRequiredFromOptions = async () => {
    const answeresCopy = await answeres;
    return checkContactRequiredFromAnswers(answeresCopy);
  };

  const validateContactForm = () => {
    if (!showContactForm) {
      return true;
    }

    const { contact_fields, contact_custom_fields } =
      survey_without_login || {};
    let hasErrors = false;

    // Validate standard contact fields
    if (contact_fields?.name?.enabled && contact_fields?.name?.required) {
      if (!contactFormData?.name?.trim()) {
        setContactFormErrors((prev) => ({
          ...prev,
          name: {
            error: true,
            message: intl.formatMessage({ id: "please-enter-your-name" }),
          },
        }));
        hasErrors = true;
      }
    }

    if (contact_fields?.email?.enabled && contact_fields?.email?.required) {
      if (!contactFormData?.email) {
        setContactFormErrors((prev) => ({
          ...prev,
          email: {
            error: true,
            message: intl.formatMessage({ id: "please-enter-your-email" }),
          },
        }));
        hasErrors = true;
      } else if (
        !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,10}$/i.test(
          contactFormData.email,
        )
      ) {
        setContactFormErrors((prev) => ({
          ...prev,
          email: {
            error: true,
            message: intl.formatMessage({ id: "invalid-email-address" }),
          },
        }));
        hasErrors = true;
      }
    }

    if (contact_fields?.phone?.enabled && contact_fields?.phone?.required) {
      if (!contactFormData?.phone) {
        setContactFormErrors((prev) => ({
          ...prev,
          phone: {
            error: true,
            message: intl.formatMessage({ id: "please-enter-your-phone" }),
          },
        }));
        hasErrors = true;
      } else {
        const countryHint =
          getPhoneCountry(
            contactFormData.phone,
            contactFormData.phoneCountry,
          ) ||
          contactFormData.phoneCountry ||
          getCompanyCountryCode();
        if (!isValidEmployeePhone(contactFormData.phone, countryHint)) {
          setContactFormErrors((prev) => ({
            ...prev,
            phone: {
              error: true,
              message: getPhoneValidationMessage(
                intl,
                countryHint,
                contactFormData.phone,
              ),
            },
          }));
          hasErrors = true;
        }
      }
    }

    // Validate custom contact fields
    if (contact_custom_fields?.length > 0) {
      contact_custom_fields.forEach((field) => {
        if (field.isRequired && !contactFormData[field.fieldKey]) {
          setContactFormErrors((prev) => ({
            ...prev,
            [field.fieldKey]: {
              error: true,
              message: `${intl.formatMessage({
                id: "please-enter",
              })} ${field.fieldName.toLowerCase()}`,
            },
          }));
          hasErrors = true;
        }

        // Email validation for custom email fields
        if (
          field.fieldType === "email" &&
          contactFormData[field.fieldKey] &&
          !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,10}$/i.test(
            contactFormData[field.fieldKey],
          )
        ) {
          setContactFormErrors((prev) => ({
            ...prev,
            [field.fieldKey]: {
              error: true,
              message: intl.formatMessage({ id: "invalid-email-address" }),
            },
          }));
          hasErrors = true;
        }

        // Phone validation for custom phone fields
        if (field.fieldType === "phone" && contactFormData[field.fieldKey]) {
          const countryHint =
            getPhoneCountry(
              contactFormData[field.fieldKey],
              contactFormData[`${field.fieldKey}Country`],
            ) ||
            contactFormData[`${field.fieldKey}Country`] ||
            getCompanyCountryCode();
          if (
            !isValidEmployeePhone(contactFormData[field.fieldKey], countryHint)
          ) {
            setContactFormErrors((prev) => ({
              ...prev,
              [field.fieldKey]: {
                error: true,
                message: getPhoneValidationMessage(
                  intl,
                  countryHint,
                  contactFormData[field.fieldKey],
                ),
              },
            }));
            hasErrors = true;
          }
        }

        // Number validation
        if (
          field.fieldType === "number" &&
          contactFormData[field.fieldKey] &&
          !/^\d+$/.test(contactFormData[field.fieldKey])
        ) {
          setContactFormErrors((prev) => ({
            ...prev,
            [field.fieldKey]: {
              error: true,
              message: `${intl.formatMessage({
                id: "please-enter-only-digits-for",
              })} ${field.fieldName.toLowerCase()}`,
            },
          }));
          hasErrors = true;
        }
      });
    }

    return !hasErrors;
  };

  // Function to update contact detail errors
  const updateContactDetailError = (key, value, message = "") => {
    if (key) {
      setContactDetailErrors((prev) => ({
        ...prev,
        [key]: { error: value, message },
      }));
    }
  };

  const questionToRender =
    edit_answer && Object.keys(edit_answer)?.length
      ? allQuestions[edit_answer?.question]
      : allQuestions[currentQuestionIndex];

  // Function to set brand details based on survey ID
  const setBrandDetails = async (survey_id) => {
    const result = await postData("api/getBrandDetail", {
      survey_id,
    });
    if (result?.status === 200) {
      // Set logo if available, otherwise use default logo
      setServeFirstBrandingHidden(result?.data?.hideServeFirst);
      setLogo(
        result?.data?.logo
          ? result?.data?.logo
          : SERVE_FIRST_LOGO_URL,
      );
      if (result?.data?.logo) {
        localStorage.setItem("logo", result?.data?.logo);
      }
      // Set survey theme based on retrieved data
      setSurveyTheme_({
        primaryColor:
          result?.data?.primaryColor !== "undefined"
            ? result?.data?.primaryColor
            : "#36473F",
        secondaryColor:
          result?.data?.secondaryColor !== "undefined"
            ? result?.data?.secondaryColor
            : "#8FA280",
        backgroundColor:
          result?.data?.backgroundColor !== "undefined"
            ? result?.data?.backgroundColor
            : "#36473F",
        highlightColor:
          result?.data?.highightColor !== "undefined"
            ? result?.data?.highightColor
            : "#8FA280",
        fontColor:
          result?.data?.fontColor !== "undefined"
            ? result?.data?.fontColor
            : "#3a3a3a",
      });
      changeTheme({
        primaryColor:
          result?.data?.primaryColor !== "undefined"
            ? result?.data?.primaryColor
            : "#36473F",
        secondaryColor:
          result?.data?.secondaryColor !== "undefined"
            ? result?.data?.secondaryColor
            : "#8FA280",
        backgroundColor:
          result?.data?.backgroundColor !== "undefined"
            ? result?.data?.backgroundColor
            : "#36473F",
        highlightColor:
          result?.data?.highightColor !== "undefined"
            ? result?.data?.highightColor
            : "#8FA280",
        fontColor:
          result?.data?.fontColor !== "undefined"
            ? result?.data?.fontColor
            : "#3a3a3a",
      });
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      const location = localStorage.getItem("location");
      const logoLocal = localStorage.getItem("logo");
      if (logoLocal) {
        setLogo(logoLocal);
      }
      if (location) {
        setEmpLoading(true);
        const detail = await getDetails(location, "forEmp");
        if (detail) {
          localStorage.setItem("employees", JSON.stringify(detail?.employee));
        }
        setEmpLoading(false);
      }
    };

    fetchData();
  }, []);

  // Effect hook to handle survey data changes
  useEffect(() => {
    clearEditAnswer_();
    if (Object?.keys(survey_without_login)?.length) {
      changeTheme({
        primaryColor: props.survey_theme.primaryColor,
        secondaryColor: props.survey_theme.secondaryColor,
      });

      const locationId = localStorage.getItem("location");
      const surveyId = localStorage.getItem("survey");

      //Set Logo and Brand detail
      setBrandDetails(surveyId);

      const results = JSON.parse(JSON.stringify(survey_without_login));
      // Keep the full API question list for hide_questions / route_to_index indices.
      // Location and schedule filters apply only to the visible list.
      const questionsOriginal = [...(results.questions || [])];
      let visibleQuestions = [...questionsOriginal];
      if (!locationId) {
        visibleQuestions = visibleQuestions.filter(
          (item) =>
            item.questionType !== "employees" &&
            item.questionType !== "inventory",
        );
      }
      visibleQuestions = filterQuestionsByScheduleWindows(visibleQuestions);

      setCurrentSurvey(results);
      setSurveyType(results.surveyType);
      setAllQuestionsOriginal(questionsOriginal);

      const hasDirectorMessage =
        results?.leadershipUser ||
        results?.visit_information ||
        results?.competitionInformation;

      let finalQuestions = [...visibleQuestions];

      if (hasDirectorMessage) {
        finalQuestions = [
          ...finalQuestions,
          { questionType: "director_message" },
        ];
      }

      setShowContactForm(false);

      setAllQuestions(finalQuestions);

      setLoading(false);
    }
  }, [survey_without_login]);

  // Monitor answers and add/remove contact form when required
  useEffect(() => {
    const fetchData = async () => {
      if (!allQuestionsOriginal?.length) return;

      const isContactRequired = await checkContactInfoRequiredFromOptions();
      if (isContactRequired !== showContactForm) {
        setShowContactForm(isContactRequired);

        await hideQuestions([]);
      }
    };

    fetchData();
  }, [answeres]);

  // State to manage question history and answers
  const [questionHistory, setQuestionHistory] = useState([]);
  const [answers, setAnswers] = useState([]);
  const [questionLoading, setQuestionLoading] = useState(false);
  // State to track hidden questions with their history positions
  const [hiddenQuestionsMap, setHiddenQuestionsMap] = useState({});
  // Ref to track if we just finished editing (to adjust index after hide)
  const wasEditingRef = useRef(false);
  // Ref to track which question was edited (to properly adjust index after)
  const editedQuestionIndexRef = useRef(null);
  // Ref to track the question ID that was being displayed before entering edit mode
  const currentQuestionBeforeEditRef = useRef(null);
  // Ref to track the latest questionHistory (to avoid stale closures)
  const questionHistoryRef = useRef([]);

  // Keep questionHistoryRef in sync with questionHistory state
  useEffect(() => {
    questionHistoryRef.current = questionHistory;
  }, [questionHistory]);

  // Track which question was being displayed when user enters edit mode
  useEffect(() => {
    if (
      edit_answer &&
      Object.keys(edit_answer)?.length &&
      currentQuestionBeforeEditRef.current === null
    ) {
      // User just entered edit mode, save the current question ID
      const currentQuestionId = allQuestions[currentQuestionIndex]?._id;
      currentQuestionBeforeEditRef.current = currentQuestionId;
    } else if (!edit_answer || !Object.keys(edit_answer)?.length) {
      // User exited edit mode without saving, reset the ref
      if (
        currentQuestionBeforeEditRef.current !== null &&
        !wasEditingRef.current
      ) {
        currentQuestionBeforeEditRef.current = null;
      }
    }
  }, [edit_answer, allQuestions, currentQuestionIndex]);

  // Function to handle question history
  const handleQuestionHistory = async (message, comment = "") => {
    if (!Object.keys(edit_answer)?.length) {
      // User is answering a NEW question (not editing)
      // Reset the "before edit" ref to ensure it doesn't interfere
      if (currentQuestionBeforeEditRef.current !== null) {
        currentQuestionBeforeEditRef.current = null;
      }

      setAnswers([
        ...answers,
        {
          question: allQuestions[currentQuestionIndex],
          answer: message,
          comment: comment,
        },
      ]);

      const isFirstQuestionAutoAnswered =
        currentQuestionIndex === 0 &&
        localStorage.getItem("question_id") === allQuestions[0]?._id &&
        localStorage.getItem("option_id");

      setCurrentQuestionIndex(currentQuestionIndex + 1);
      setQuestionLoading(true);

      if (currentQuestionIndex !== allQuestions?.length - 1) {
        // Only play audio if it's not auto-answered first question
        if (!isFirstQuestionAutoAnswered) {
          const audio1 = new Audio(sound2);
          audio1.play().catch((err) => console.log("Audio play blocked:", err));
        }
      }

      await new Promise((resolve) => setTimeout(resolve, 1000));
      setQuestionLoading(false);
    } else {
      // We're saving an edited answer, set flag to adjust index after hide
      wasEditingRef.current = true;
      editedQuestionIndexRef.current = edit_answer.question;
    }
    clearEditAnswer_();
    setTimeout(() => {
      // Don't call if last question is answered and it is not a multi select question
      const isLastQuestion = currentQuestionIndex === allQuestions.length - 1;
      const isMultiSelectQuestion = [
        "multiselect",
        "skills",
        "sequence",
      ]?.includes(allQuestions[currentQuestionIndex]?.questionType);
      if (isLastQuestion && !isMultiSelectQuestion) return;
      let contactDetails = survey?.contactDetails;
      savePartialResponseForMobile({
        allQuestions,
        currentQuestionIndex,
        getHiddenQuestionIds,
        store,
        contactDetails,
        customValues,
        contactFormData,
        guest_info,
        visitDate,
        visitTimeIn,
        selectedTimeOut,
        survey_without_login,
        showContactForm,
        directorMessage,
      });
    }, 0);
  };

  // Build history from answers state (when answering during current session)
  useEffect(() => {
    answers?.forEach((answer) => {
      const questionText = answer?.question?.text;
      const answerText = `${
        answer?.question?.questionType === "inventory"
          ? answer?.answer?.length
            ? answer?.answer
                ?.map((ans) => `${ans?.product}: ${ans?.value}`)
                .join(", ")
            : ""
          : Array.isArray(answer?.answer)
            ? answer?.answer.join(", ") || ""
            : answer?.answer
      }`;

      const questionExist = questionHistory?.some(
        (q) => q?._id === answer?.question?._id,
      );
      if (!questionExist) {
        setQuestionHistory((prevHistory) => {
          const newHistory = [
            ...prevHistory,
            {
              text: questionText,
              fromUser: false,
              _id: answer?.question?._id,
              question: answer?.question,
            },
            {
              text: answerText,
              fromUser: true,
              type: answer?.question?.questionType,
              question: answer?.question,
              comment: answer?.comment,
              currentQuestionIndex: currentQuestionIndex,
            },
          ];
          // Update ref immediately to avoid stale history in hideQuestions
          questionHistoryRef.current = newHistory;
          return newHistory;
        });
      }
    });
  }, [answers]);

  // Rebuild history from Redux on mount/when allQuestions changes (handles page reload)
  useEffect(() => {
    if (!allQuestions?.length || !allQuestionsOriginal?.length) return;

    // Don't rebuild during edit mode - let hideQuestions handle history updates
    if (edit_answer && Object.keys(edit_answer)?.length) return;

    // Only rebuild if history is empty or incomplete
    const answeredQuestionIds = Object.keys(answeres);
    const visibleAnsweredQuestions = allQuestions.filter((q) =>
      answeredQuestionIds.includes(q._id),
    );

    // If we have answered questions but history is empty/incomplete, rebuild it
    if (
      visibleAnsweredQuestions.length > 0 &&
      questionHistory.length < visibleAnsweredQuestions.length * 2
    ) {
      const newHistory = [];

      // Build history for all visible questions that have answers
      allQuestions.forEach((question) => {
        const answer = answeres[question._id];
        if (answer?.value !== undefined) {
          // Format answer text
          let answerText = "";
          if (question.questionType === "inventory") {
            answerText = Array.isArray(answer.value)
              ? answer.value
                  .map((ans) => `${ans?.product}: ${ans?.value}`)
                  .join(", ")
              : "";
          } else if (question.questionType === "grid") {
            answerText = "[object Object]";
          } else if (Array.isArray(answer.value)) {
            answerText = answer.value.join(", ") || "";
          } else {
            answerText = answer.value || "";
          }

          // Add question and answer to history
          newHistory.push(
            {
              text: question.text,
              fromUser: false,
              _id: question._id,
              question: question,
            },
            {
              text: answerText,
              fromUser: true,
              type: question.questionType,
              question: question,
              comment: answer.comment || "",
              currentQuestionIndex: currentQuestionIndex,
            },
          );
        }
      });

      if (newHistory.length > questionHistory.length) {
        setQuestionHistory(newHistory);
        // Update ref immediately to avoid stale history
        questionHistoryRef.current = newHistory;
      }
    }
  }, [allQuestions, answeres, edit_answer]);

  useEffect(() => {
    if (edit_answer && Object.keys(edit_answer).length) return;
    const current = allQuestions[currentQuestionIndex];
    if (!current?._id || !questionHistory?.length) return;
    const alreadyInChat = questionHistory.some(
      (chat) => !chat?.fromUser && chat?.question?._id === current._id,
    );
    if (!alreadyInChat) return;
    const nextIndex = allQuestions.findIndex((question, index) => {
      if (index <= currentQuestionIndex) return false;
      return !questionHistory.some(
        (chat) => !chat?.fromUser && chat?.question?._id === question._id,
      );
    });
    if (nextIndex >= 0) {
      setCurrentQuestionIndex(nextIndex);
    } else if (currentQuestionIndex < allQuestions.length) {
      // Current and all following questions are already in history (e.g. after
      // reload). Advance past the list so the final submit bar is shown instead
      // of hiding the inline gridspot input with no way to proceed.
      setCurrentQuestionIndex(allQuestions.length);
    }
  }, [questionHistory, currentQuestionIndex, allQuestions, edit_answer]);

  // Auto-proceed when both answer and required image exist for radio questions
  useEffect(() => {
    if (allQuestions.length > 0 && currentQuestionIndex < allQuestions.length) {
      const currentQuestion = allQuestions[currentQuestionIndex];
      const questionAnswer = answeres[currentQuestion?._id];

      if (currentQuestion?.questionType === "radio" && questionAnswer?.value) {
        const selectedOption = currentQuestion?.options?.find(
          (opt) => opt._id === questionAnswer.value,
        );

        if (
          selectedOption?.image_required &&
          questionAnswer?.image?.length > 0
        ) {
          // Both answer and required image exist - auto proceed to next question
          setTimeout(() => {
            handleQuestionHistory(selectedOption.text);
          }, 500); // Small delay to ensure smooth UX
        }
      }

      if (
        currentQuestion?.questionType === "multiselect" &&
        questionAnswer?.value?.length > 0
      ) {
        const selectedOptions = currentQuestion?.options?.filter((opt) =>
          questionAnswer.value.includes(opt._id),
        );

        if (
          selectedOptions?.some((opt) => opt?.image_required) &&
          questionAnswer?.image?.length > 0
        ) {
          // Both answer and required image exist - auto proceed to next question
          const selectedTexts = selectedOptions
            .map((opt) => opt.text)
            .join(", ");
          setTimeout(() => {
            handleQuestionHistory(selectedTexts);
          }, 500); // Small delay to ensure smooth UX
        }
      }

      if (
        currentQuestion?.questionType === "dropdown" &&
        questionAnswer?.value
      ) {
        const selectedOption = currentQuestion?.options?.find(
          (opt) => opt._id === questionAnswer.value,
        );

        if (
          selectedOption?.image_required &&
          questionAnswer?.image?.length > 0
        ) {
          // Both answer and required image exist - auto proceed to next question
          setTimeout(() => {
            handleQuestionHistory(selectedOption.text);
          }, 500); // Small delay to ensure smooth UX
        }
      }
    }
  }, [answeres, currentQuestionIndex, allQuestions]);

  const routeToIndex = (indexToSkip, questionID) => {
    // Use original list so route_to_index stays correct when schedule/hide
    // removed questions from the visible list.
    const parsedIndexToSkip = toQuestionIndex(indexToSkip);
    if (parsedIndexToSkip == null) return;

    const currentVisibleIndex = allQuestions.findIndex(
      (q) => q._id === questionID,
    );
    if (currentVisibleIndex === allQuestions.length - 1) return;

    const currentQuestionIndex = allQuestionsOriginal.findIndex(
      (q) => q._id === questionID,
    );
    if (currentQuestionIndex < 0) return;

    if (
      currentQuestionIndex >= 0 &&
      currentQuestionIndex <= parsedIndexToSkip &&
      parsedIndexToSkip < allQuestionsOriginal.length
    ) {
      // Create a new array of questions by slicing the original questions array
      let newData = [
        ...allQuestionsOriginal.slice(0, currentQuestionIndex + 1),
        ...allQuestionsOriginal.slice(parsedIndexToSkip),
      ];
      newData = filterQuestionsByScheduleWindows(newData);
      // Check if location is available, and filter out employee-related questions if not
      const locationId = localStorage.getItem("location");
      if (!locationId) {
        newData = newData.filter(
          (item) =>
            item.questionType !== "employees" &&
            item.questionType !== "inventory",
        );
      }
      const needsDirectorMessage =
        survey_without_login?.leadershipUser ||
        survey_without_login?.visit_information ||
        survey_without_login?.competitionInformation;

      const isContactRequired = checkContactRequiredFromAnswers(answeres);

      if (needsDirectorMessage) {
        newData = [...newData, { questionType: "director_message" }];
      }

      if (isContactRequired) {
        newData = [...newData, { questionType: "contact_form" }];
      }

      setAllQuestions(newData);
    }
  };

  // Helper function to get hide questions from a single question/answer
  const getHideQuestionsFromAnswer = (question, answerValue) => {
    if (!answerValue) return [];

    const hideQues = [];

    if (["radio", "rating", "emoji"].includes(question.questionType)) {
      const selectedOption = question.options?.find(
        (opt) => opt?._id === answerValue,
      );
      if (selectedOption?.hide_questions) {
        hideQues.push(...selectedOption.hide_questions);
      }
    } else if (
      ["multiselect", "sequence", "skills"].includes(question.questionType)
    ) {
      const selectedOptions = question.options?.filter((opt) =>
        answerValue?.includes(opt?._id),
      );
      selectedOptions?.forEach((opt) => {
        if (opt.hide_questions) hideQues.push(...opt.hide_questions);
      });
    } else if (question.questionType === "gridspot") {
      // Gridspot-only: answers are ObjectId[]. Radio uses first id; multiselect
      // unions hide_questions from every selected spot (same as API).
      const selectedIds = Array.isArray(answerValue)
        ? answerValue
        : [answerValue];
      const idMatches = (optId, selectedId) =>
        String(optId) === String(selectedId);
      if (question.gridInputType === "multiselect") {
        const selectedOptions = question.options?.filter((opt) =>
          selectedIds?.some((id) => idMatches(opt?._id, id)),
        );
        selectedOptions?.forEach((opt) => {
          if (opt.hide_questions) hideQues.push(...opt.hide_questions);
        });
      } else {
        const selectedOption = question.options?.find((opt) =>
          idMatches(opt?._id, selectedIds[0]),
        );
        if (selectedOption?.hide_questions) {
          hideQues.push(...selectedOption.hide_questions);
        }
      }
    }

    return hideQues;
  };

  const hideQuestions = async (indexToHide, questionID, selectedId) => {
    // Safety check: if we have stale refs from a previous edit
    // and we're now processing a NEW answer (not an edit), reset ALL refs
    if (!Object.keys(edit_answer || {})?.length) {
      // We're processing a new answer, not an edit
      // Reset all edit-related refs to prevent the adjustment from running again
      if (currentQuestionBeforeEditRef.current !== null) {
        currentQuestionBeforeEditRef.current = null;
      }
      if (editedQuestionIndexRef.current !== null) {
        editedQuestionIndexRef.current = null;
      }
      if (wasEditingRef.current) {
        wasEditingRef.current = false;
      }
    }

    const locationId = localStorage.getItem("location");
    const answeresCopy = await answeres;
    const hideQues = [];
    const waitTimeOptId = "6909f6d55fc3f8e6e5665337"; // Option Id of (Queue/Wait times) option
    const dependentQuestionId = "6901e547863588f134b25c65"; // Question Id of (How long did you wait in line?) question
    const indexOfQuestion = allQuestionsOriginal.findIndex(
      (question) => question._id === dependentQuestionId,
    );
    let allSelectedAnswers = [];

    for (let index = 0; index < allQuestions.length; index++) {
      if (allQuestions[index]._id in answeresCopy) {
        let prevAnswer = answeresCopy[allQuestions[index]._id];

        const answerToCheck =
          allQuestions[index]._id === questionID
            ? selectedId
            : prevAnswer?.value;

        // Handle grid-specific hide questions
        if (allQuestions[index]?.questionType === "grid") {
          const gridHideQues = collectGridHideQuestions(
            answerToCheck,
            allQuestions[index],
          );
          hideQues.push(...gridHideQues);
        }

        // Use helper function to get hidden questions for normal question types
        const hideIndices = getHideQuestionsFromAnswer(
          allQuestions[index],
          answerToCheck,
        );
        hideQues.push(...hideIndices);

        // Collect all selected answers (answerToCheck already handles current vs previous)
        if (answerToCheck && Array.isArray(answerToCheck)) {
          allSelectedAnswers.push(...answerToCheck);
        } else {
          allSelectedAnswers.push(answerToCheck);
        }
      }
    }
    let allHiddenIndex = [
      ...normalizeQuestionIndices(hideQues),
      ...normalizeQuestionIndices(indexToHide),
    ];
    /* DELETE ME : once the show question logic is implemented, then remove this condition */
    // remove the indexOfQuestion from allHiddenIndex if it exists
    allSelectedAnswers = [...new Set(allSelectedAnswers)];
    if (allSelectedAnswers?.includes(waitTimeOptId)) {
      allHiddenIndex = allHiddenIndex.filter(
        (index) => index !== indexOfQuestion,
      );
    }
    const hiddenIndexSet = new Set(allHiddenIndex);

    // Get the questions that are being hidden
    let hiddenQuestions = allQuestionsOriginal?.filter((que, i) =>
      hiddenIndexSet.has(i),
    );

    // Variable to track the latest history state throughout this function
    let latestQuestionHistory = questionHistoryRef.current;

    // Only update history if there are questions to hide or unhide
    const hasQuestionsToHide = hiddenQuestions.length > 0;
    const hasQuestionsTracked = Object.keys(hiddenQuestionsMap).length > 0;

    if (hasQuestionsToHide || hasQuestionsTracked) {
      // Use ref to get the latest questionHistory (avoids stale closure)
      const currentQuestionHistory = questionHistoryRef.current;

      // Process hidden questions in history using helper function
      const { updatedHistory, updatedMap, questionsToUnhide } =
        processHiddenQuestionsInHistory(
          currentQuestionHistory,
          hiddenQuestions,
          hiddenQuestionsMap,
        );

      let updatedQuestionHistory = updatedHistory;
      let newHiddenQuestionsMap = updatedMap;

      // Restore unhidden questions to their original positions in history
      questionsToUnhide.forEach((questionId) => {
        updatedQuestionHistory = restoreUnhiddenQuestionToHistory(
          updatedQuestionHistory,
          questionId,
          allQuestionsOriginal,
          answeresCopy,
          newHiddenQuestionsMap,
          currentQuestionIndex,
        );

        // Remove from hidden map
        delete newHiddenQuestionsMap[questionId];
      });

      // Update our tracking variable with the latest history
      latestQuestionHistory = updatedQuestionHistory;

      setQuestionHistory(updatedQuestionHistory);
      // Update ref immediately to avoid stale history
      questionHistoryRef.current = updatedQuestionHistory;
      setHiddenQuestionsMap(newHiddenQuestionsMap);
    }

    // Filter out questions to be hidden based on their indices
    let filteredQuestions = allQuestionsOriginal?.filter(
      (_, i) => !hiddenIndexSet.has(i),
    );
    // Keep schedule_windows filtering on the visible list only
    filteredQuestions = filterQuestionsByScheduleWindows(filteredQuestions);

    // Do Not Remove answers for the hidden questions for now
    // Remove answers for the hidden questions
    // let hiddenQuestions = allQuestionsOriginal?.filter((que, i) =>
    //   indexToHide?.includes(i)
    // );
    // hiddenQuestions?.forEach((hiddenQue) =>
    //   removeAnswer_({ id: hiddenQue?._id })
    // );

    // Filter by location and append additional questions using helper functions
    filteredQuestions = filterByLocation(filteredQuestions, !!locationId);
    const isContactRequired = checkContactRequiredFromAnswers(answeresCopy);
    filteredQuestions = appendAdditionalQuestions(
      filteredQuestions,
      survey_without_login,
      isContactRequired,
    );

    // Adjust currentQuestionIndex only if we just finished editing
    // Handle both hiding and unhiding adjustments
    if (wasEditingRef.current && editedQuestionIndexRef.current !== null) {
      const newIndex = calculatePostEditQuestionIndex(
        currentQuestionBeforeEditRef.current, // Pass the question ID that was displayed before editing
        filteredQuestions,
        allQuestions,
        currentQuestionIndex,
      );

      setCurrentQuestionIndex(newIndex);

      // Handle questions that were never in history but are now unhidden
      // (e.g., Q2 hidden by Q1 before Q2 was ever answered)
      const currentlyVisibleQuestionIds = new Set(
        allQuestions.map((q) => q._id).filter(Boolean),
      );
      const willBeVisibleQuestionIds = new Set(
        filteredQuestions.map((q) => q._id).filter(Boolean),
      );

      // Add newly visible questions to history using helper function
      // Use latestQuestionHistory which includes all updates from the previous section
      if (latestQuestionHistory.length > 0) {
        const updatedHistory = addNewlyVisibleQuestionsToHistory(
          latestQuestionHistory,
          currentlyVisibleQuestionIds,
          willBeVisibleQuestionIds,
          allQuestionsOriginal,
          allQuestions,
          answeresCopy,
          currentQuestionIndex,
        );

        if (updatedHistory.length > latestQuestionHistory.length) {
          setQuestionHistory(updatedHistory);
          // Update ref immediately to avoid stale history
          questionHistoryRef.current = updatedHistory;
          // Update tracking variable for any future operations
          latestQuestionHistory = updatedHistory;
        }
      }

      // Reset the flags after all adjustments
      wasEditingRef.current = false;
      editedQuestionIndexRef.current = null;
      currentQuestionBeforeEditRef.current = null; // Reset this too
    }

    setAllQuestions(filteredQuestions);
  };

  /* 
  @param actualAnswers: The answers to the question
  @param questionID: The ID of the question
  @returns: An array of question IDs to hide
  @description: This function is used to get the questions to hide based on the answers to the question
  */
  const getGridHideQuestions = (actualAnswers, questionID) => {
    const hideQuestions = [];
    const question = allQuestionsOriginal.find((q) => q._id === questionID);
    if (actualAnswers && Object.keys(actualAnswers)?.length > 0) {
      Object.keys(actualAnswers)?.forEach((rowId) => {
        const selectedOptionId = actualAnswers[rowId];

        // Handle both single selection and multi-selection
        const selectedOptionIds = Array.isArray(selectedOptionId)
          ? selectedOptionId
          : [selectedOptionId];

        selectedOptionIds?.forEach((optionId) => {
          // Find the option that matches the selected optionId
          const selectedOption = question?.options?.find(
            (option) => option._id === optionId,
          );

          // Check if this option has grid_hide_questions array
          if (
            selectedOption &&
            selectedOption?.grid_hide_questions &&
            Array.isArray(selectedOption?.grid_hide_questions)
          ) {
            // Find the specific hide question configuration for this rowId
            const hideQuestionConfig = selectedOption.grid_hide_questions.find(
              (config) => config.rowId === rowId,
            );

            // If found, add the hide_questions for this rowId
            if (
              hideQuestionConfig &&
              hideQuestionConfig.hide_questions &&
              Array.isArray(hideQuestionConfig.hide_questions)
            ) {
              hideQuestions.push(...hideQuestionConfig.hide_questions);
            }
          }
        });
      });
    }
    return hideQuestions;
  };

  /* 
  @param actualAnswers: The answers to the question
  @param questionID: The ID of the question
  @returns: An array of question IDs to hide
  @description: This function is used to hide the questions
  */
  const gridHideQuestions = async (actualAnswers, questionID) => {
    // Safety check: if we have stale refs from a previous edit
    // and we're now processing a NEW answer (not an edit), reset ALL refs
    if (!Object.keys(edit_answer || {})?.length) {
      // We're processing a new answer, not an edit
      // Reset all edit-related refs to prevent the adjustment from running again
      if (currentQuestionBeforeEditRef.current !== null) {
        currentQuestionBeforeEditRef.current = null;
      }
      if (editedQuestionIndexRef.current !== null) {
        editedQuestionIndexRef.current = null;
      }
      if (wasEditingRef.current) {
        wasEditingRef.current = false;
      }
    }

    const answeresCopy = await answeres;

    const hideQuestions = [];
    const gridHideQuestions = getGridHideQuestions(actualAnswers, questionID);

    // Loop through the questions and find the ones that need to be hidden
    for (let index = 0; index < allQuestions.length; index++) {
      // Skip the current question being answered - it's already handled by getGridHideQuestions
      if (allQuestions[index]?._id === questionID) {
        continue;
      }

      let prevAnswer = answeresCopy[allQuestions[index]._id];

      // Only process if this question has been answered
      if (prevAnswer && allQuestions[index]._id in answeresCopy) {
        // Handle grid-specific hide questions
        if (allQuestions[index]?.questionType === "grid") {
          const gridHideQues = collectGridHideQuestions(
            prevAnswer?.value,
            allQuestions[index],
          );
          hideQuestions.push(...gridHideQues);
        }

        // Get normal hide questions (radio, rating, emoji, etc.)
        const normalHideQuestions = getHideQuestionsFromAnswer(
          allQuestions[index],
          prevAnswer?.value,
        );
        hideQuestions.push(...normalHideQuestions);
      }
    }

    // Combine indices to be hidden
    const allHiddenIndex = [...hideQuestions, ...gridHideQuestions];
    // Remove duplicates from hide questions array (normalize string digits)
    const uniqueHideQuestions = [
      ...new Set(normalizeQuestionIndices(allHiddenIndex)),
    ];
    if (uniqueHideQuestions?.length > 0) {
      const hiddenIndexSet = new Set(uniqueHideQuestions);
      // Filter out questions to be hidden based on their indices
      let filteredQuestions = allQuestionsOriginal?.filter(
        (_, i) => !hiddenIndexSet.has(i),
      );
      filteredQuestions = filterQuestionsByScheduleWindows(filteredQuestions);

      // Get the questions that are being hidden
      let hiddenQuestions = allQuestionsOriginal?.filter((que, i) =>
        hiddenIndexSet.has(i),
      );
      // hiddenQuestions?.forEach((hiddenQue) =>
      //   removeAnswer_({ id: hiddenQue?._id })
      // );

      // Only update history if there are questions to hide or unhide
      const hasQuestionsToHide = hiddenQuestions.length > 0;
      const hasQuestionsTracked = Object.keys(hiddenQuestionsMap).length > 0;

      if (hasQuestionsToHide || hasQuestionsTracked) {
        // Use ref to get the latest questionHistory (avoids stale closure)
        const currentQuestionHistory = questionHistoryRef.current;

        // Process hidden questions in history using helper function
        const { updatedHistory, updatedMap } = processHiddenQuestionsInHistory(
          currentQuestionHistory,
          hiddenQuestions,
          hiddenQuestionsMap,
        );

        setQuestionHistory(updatedHistory);
        // Update ref immediately to avoid stale history
        questionHistoryRef.current = updatedHistory;
        setHiddenQuestionsMap(updatedMap);
      }

      // Do Not Remove answers for the hidden questions - keep them in Redux
      // This allows answers to be preserved when questions are unhidden

      // Filter by location and append additional questions using helper functions
      const locationId = localStorage.getItem("location");
      filteredQuestions = filterByLocation(filteredQuestions, !!locationId);
      const isContactRequired = checkContactRequiredFromAnswers(answeresCopy);
      let allQues = appendAdditionalQuestions(
        filteredQuestions,
        survey_without_login,
        isContactRequired,
      );

      // Adjust currentQuestionIndex only if we just finished editing
      // Handle both hiding and unhiding adjustments
      if (wasEditingRef.current && editedQuestionIndexRef.current !== null) {
        const newIndex = calculatePostEditQuestionIndex(
          currentQuestionBeforeEditRef.current, // Pass the question ID that was displayed before editing
          allQues,
          allQuestions,
          currentQuestionIndex,
        );

        setCurrentQuestionIndex(newIndex);

        // Reset the flags after adjustment
        wasEditingRef.current = false;
        editedQuestionIndexRef.current = null;
        currentQuestionBeforeEditRef.current = null; // Reset this too
      }

      // Handle questions that were never in history but are now unhidden
      // (e.g., Q2 hidden by Q1 before Q2 was ever answered)
      const currentlyVisibleQuestionIds = new Set(
        allQuestions.map((q) => q._id).filter(Boolean),
      );
      const willBeVisibleQuestionIds = new Set(
        allQues.map((q) => q._id).filter(Boolean),
      );

      // Add newly visible questions to history using helper function
      const currentQuestionHistory = questionHistoryRef.current;
      const updatedHistory = addNewlyVisibleQuestionsToHistory(
        currentQuestionHistory,
        currentlyVisibleQuestionIds,
        willBeVisibleQuestionIds,
        allQuestionsOriginal,
        allQuestions,
        answeresCopy,
        currentQuestionIndex,
      );

      if (updatedHistory.length > currentQuestionHistory.length) {
        setQuestionHistory(updatedHistory);
        // Update ref immediately to avoid stale history
        questionHistoryRef.current = updatedHistory;
      }

      // Update the state with the filtered questions
      setAllQuestions(allQues);

      return uniqueHideQuestions;
    }
  };

  const [customValuesErrors, setCustomValuesErrors] = useState({});

  const validateCompetitionCustomValues = () => {
    let hasErrors = false;
    const customFields = survey_without_login?.customValues;
    if (
      survey_without_login?.competitionInformation &&
      customFields?.fields?.length > 0
    ) {
      // Validate custom values
      customFields?.fields?.forEach((item) => {
        if (item.isRequired && !customValues[item.fieldKey]) {
          setCustomValuesErrors((prev) => ({
            ...prev,
            [item.fieldKey]: {
              error: true,
              message: `${intl.formatMessage({
                id: "please-enter",
              })} ${item.fieldName.toLowerCase()}`,
            },
          }));
          hasErrors = true;
        } else if (
          item.fieldType === "email" &&
          customValues[item.fieldKey] &&
          !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,10}$/i.test(
            customValues[item.fieldKey],
          )
        ) {
          setCustomValuesErrors((prev) => ({
            ...prev,
            [item.fieldKey]: {
              error: true,
              message: intl.formatMessage({
                id: "invalid-email-address",
              }),
            },
          }));
          hasErrors = true;
        } else if (
          item.fieldType === "number" &&
          customValues[item.fieldKey] &&
          !/^\d+$/.test(customValues[item.fieldKey])
        ) {
          setCustomValuesErrors((prev) => ({
            ...prev,
            [item.fieldKey]: {
              error: true,
              message: `${intl.formatMessage({
                id: "please-enter-only-digits-for",
              })} ${item.fieldName.toLowerCase()}`,
            },
          }));
          hasErrors = true;
        } else if (item.fieldType === "phone" && customValues[item.fieldKey]) {
          const countryHint =
            getPhoneCountry(
              customValues[item.fieldKey],
              customValues[`${item.fieldKey}Country`],
            ) ||
            customValues[`${item.fieldKey}Country`] ||
            getCompanyCountryCode();
          if (!isValidEmployeePhone(customValues[item.fieldKey], countryHint)) {
            setCustomValuesErrors((prev) => ({
              ...prev,
              [item.fieldKey]: {
                error: true,
                message: getPhoneValidationMessage(
                  intl,
                  countryHint,
                  customValues[item.fieldKey],
                ),
              },
            }));
            hasErrors = true;
          }
        }
      });
    }
    return hasErrors;
  };

  // Calculate which questions should be hidden based on current answers
  const getHiddenQuestionIds = async () => {
    let hideQues = [];
    const answeresCopy = await answeres;
    const waitTimeOptId = "6909f6d55fc3f8e6e5665337"; // Option Id of (Queue/Wait times) option // DELETE ME : once the show question logic is implemented, then remove this condition
    const dependentQuestionId = "6901e547863588f134b25c65"; // Question Id of (How long did you wait in line?) question // DELETE ME : once the show question logic is implemented, then remove this condition
    const indexOfQuestion = allQuestionsOriginal.findIndex(
      (question) => question._id === dependentQuestionId,
    );

    for (let index = 0; index < allQuestionsOriginal?.length; index++) {
      const question = allQuestionsOriginal[index];
      const answer = answeresCopy?.[question?._id];

      // Use helper function
      const hideIndices = getHideQuestionsFromAnswer(question, answer?.value);
      hideQues.push(...hideIndices);
      // DELETE ME : once the show question logic is implemented, then remove this condition
      if (
        answer?.value &&
        (Array.isArray(answer.value) || typeof answer.value === "string") &&
        answer.value.includes(waitTimeOptId) &&
        normalizeQuestionIndices(hideQues).includes(indexOfQuestion)
      ) {
        hideQues = hideQues.filter(
          (index) => toQuestionIndex(index) !== indexOfQuestion,
        );
      }
    }

    // Convert indices to question IDs (API may send string digits)
    return normalizeQuestionIndices(hideQues)
      .map((index) => allQuestionsOriginal[index]?._id)
      .filter(Boolean);
  };

  /**
   * Partial survey exit (mobile conversational view): save current state
   * and either close the tab or redirect to the thank-you page. No
   * question/contact validation, mirrors the desktop Save & Exit flow.
   */
  const handleSaveAndExit = async () => {
    if (loading) {
      return;
    }
    setLoading(true);
    try {
      const result = await savePartialResponseOnExit({
        allQuestions,
        getHiddenQuestionIds,
        store,
        contactDetails: survey?.contactDetails,
        customValues,
        contactFormData,
        guest_info,
        visitDate,
        visitTimeIn,
        selectedTimeOut,
        survey_without_login,
        showContactForm,
        directorMessage,
      });
      if (result?.success) {
        attemptCloseTabOrRedirect(history, {
          surveyWithoutLogin: true,
          partialExit: true,
        });
        return;
      }
      const csatCode = csatErrorCode(result?.error);
      if (csatCode === CSAT_ERROR_CODES.ALREADY_SUBMITTED) {
        // This CSAT email was already answered (another tab or device).
        history.push("/sameDaySurvey");
        return;
      }
      toast.error(
        intl.formatMessage({
          id:
            csatCode === CSAT_ERROR_CODES.TOKEN_INVALID
              ? "csat-link-invalid"
              : "failed-to-save-and-exit",
        }),
      );
      setLoading(false);
    } catch (error) {
      console.log(error);
      toast.error(intl.formatMessage({ id: "failed-to-save-and-exit" }));
      setLoading(false);
    }
  };

  // Add a ref to store the timeout ID
  const autoCloseTimeoutRef = useRef(null);

  const handleClosePage = () => {
    // Clear the timeout when user manually closes
    if (autoCloseTimeoutRef.current) {
      clearTimeout(autoCloseTimeoutRef.current);
      autoCloseTimeoutRef.current = null;
    }
    setShowErrorPopup({ show: false });
  };

  useEffect(() => {
    if (showErrorPopup?.show) {
      // Store the timeout ID
      autoCloseTimeoutRef.current = setTimeout(() => {
        window.close();
      }, 5000);
    }

    // Cleanup function - clear timeout when component unmounts or effect re-runs
    return () => {
      if (autoCloseTimeoutRef.current) {
        clearTimeout(autoCloseTimeoutRef.current);
        autoCloseTimeoutRef.current = null;
      }
    };
  }, [showErrorPopup]);

  const submitAnswers = async (initiatedBy = "") => {
    // Consolidating response data from the contact details
    let responseData = {
      customer_name: survey?.contactDetails.name,
      customer_email: survey?.contactDetails.email,
      customer_phone: survey?.contactDetails.phone,
    };

    // If submission is from idle, collect all errors and show a popup
    if (initiatedBy === "idle") {
      const errors = [];

      const isContactFormValid = validateContactForm();
      if (!isContactFormValid) {
        errors.push(
          intl.formatMessage({
            id: "please-complete-all-required-contact-information",
          }),
        );
      }

      const hasErrors = validateCompetitionCustomValues();
      if (hasErrors) {
        errors.push(
          intl.formatMessage({ id: "please-correct-the-custom-field-values" }),
        );
      }

      // Check answers early when from idle
      let answeresCopy = await { ...answeres };
      // Remove empty or null values from the answersCopy object
      answeresCopy = removeEmptyOrNullValuesFromAnswersCopy(answeresCopy);

      if (!Object.keys(answeresCopy)?.length) {
        errors.push(
          intl.formatMessage({
            id: "you-must-provide-at-least-one-answer-before-submitting-the-survey",
          }),
        );
      }

      // If there are any errors, show popup and return
      if (errors?.length > 0) {
        // Show a modal/popup with all error messages
        setShowErrorPopup({
          title: intl.formatMessage({ id: "survey-cannot-be-submitted" }),
          errors: errors,
          show: true,
        });
        setLoading(false);
        return;
      }
    }

    const hasErrors = validateCompetitionCustomValues();
    if (hasErrors) {
      return;
    }

    const currentQuestion = allQuestions[currentQuestionIndex];
    const isOnContactFormPage =
      currentQuestion?.questionType === "contact_form";

    if (isOnContactFormPage) {
      const isContactFormValid = validateContactForm();
      if (!isContactFormValid) {
        toast.error(
          intl.formatMessage({
            id: "please-fill-all-required-contact-information",
          }),
        );
        return;
      }
    }

    const formattedData = Object.entries(customValues).map(([key, value]) => ({
      fieldKey: key,
      value: value,
    }));

    if (currentSurvey?.visit_information && selectedTimeOut === null) {
      toast.error(intl.formatMessage({ id: "please-select-time" }));
      return;
    }
    setLoading(true); // Sets loading state to true at the start of the function
    let filesArray = [];
    let isAllowGoogleQR = false;
    // Destructuring survey data including answers and contact details
    const answeresCopy = await { ...answeres };
    // Loop through answers to find and process file type questions
    for (let item in answeresCopy) {
      const question = allQuestions.find((question) => question._id === item);
      if (question !== undefined) {
        if ("isFile" in answeresCopy[item]) {
          // Determine the question type for file-based questions
          answeresCopy[item].questionType =
            question?.questionType === "handwrittenInput"
              ? "base64"
              : question?.questionType;
          // Push file data to the filesArray
          filesArray.push({ [item]: answeresCopy[item] });
        }
        // Format phone numbers: E.164 value + dial code + ISO country
        if (
          question?.questionType === "text" &&
          question?.textType === "phone" &&
          answeresCopy[item].value !== ""
        ) {
          const formatted = formatPhoneAnswerForPayload(answeresCopy[item]);
          if (formatted) {
            answeresCopy[item] = formatted;
          }
        }
        // Remove empty or null values from the answersCopy object
        if (
          !answeresCopy[item]?.value ||
          (Array.isArray(answeresCopy[item].value) &&
            answeresCopy[item].value.length === 0)
        ) {
          delete answeresCopy[item];
        }
        if (
          answeresCopy[item]?.value &&
          question?.options?.find(
            (opt) =>
              opt?._id?.toString() === answeresCopy[item].value?.toString(),
          )?.allow_google_review
        ) {
          isAllowGoogleQR = true;
        }
      }
    }
    // Check if there are no answers provided
    if (!Object.keys(answeresCopy)?.length) {
      setLoading(false);
      toast.error(
        intl.formatMessage({
          id: "you-must-provide-at-least-one-answer-before-submitting-the-survey",
        }),
      );
      return;
    }

    // Calculate the total score of the survey
    let surveyTotal = 0;
    for (let index = 0; index < allQuestions.length; index++) {
      const question = allQuestions[index];
      surveyTotal += question?.maxScore ? question?.maxScore : 0;
    }

    const hiddenQuestionIds = await getHiddenQuestionIds();

    // Remove hidden question answers
    hiddenQuestionIds?.length > 0 &&
      hiddenQuestionIds?.forEach((questionId) => {
        delete answeresCopy[questionId];
      });

    // Preparing metadata for the survey response
    const metaData = {
      survey_id: localStorage.getItem("survey") || "",
      location_id: localStorage.getItem("location") || "",
      response_user_id: localStorage.getItem("user_id") || "",
      tag_id: localStorage.getItem("tag_id")
        ? localStorage.getItem("tag_id")
        : localStorage.getItem("tag"),
    };
    withCsatToken(metaData); // CSAT email link: which email this answers

    if (survey_without_login?.visit_information) {
      metaData.visitDate = visitDate;
      metaData.visitTimeIn = visitTimeIn;
      metaData.visitTimeOut = selectedTimeOut
        ? moment(selectedTimeOut).format("HH:mm")
        : null;
    }
    if (survey_without_login?.guest_info) {
      metaData.guest_info = guest_info;
    }

    // Handling audit and email data if available
    const audit = localStorage.getItem("audit") ?? null;
    const email = localStorage.getItem("email") ?? null;
    if (audit) {
      metaData.audit = audit;
      metaData.email = email;
    }
    // Add Login user detail
    const userEmail = localStorage.getItem("user_email") ?? null;
    if (userEmail) {
      metaData.email = userEmail;
    }
    // Add creator_id if available in localstorage
    const ticketCreatorId = localStorage.getItem("creator_id") ?? null;

    // Add call center flag if available in localstorage
    const callcenter = localStorage.getItem("callcenter") ?? null;
    if (callcenter === "true") {
      responseData.call_center = true;
    }

    // Add source if available in localstorage
    const source = localStorage.getItem("source") ?? null;

    const override_id = localStorage.getItem("override_id") ?? null;
    if (override_id) {
      metaData.override_id = override_id;
    }

    const task_id = localStorage.getItem("task_id") ?? null;
    if (task_id) {
      metaData.task_id = task_id;
    }

    const is_override = localStorage.getItem("is_override") ?? null;
    if (is_override) {
      metaData.is_override = is_override;
    }

    const override_date = localStorage.getItem("override_date") ?? null;
    if (override_date) {
      metaData.override_date = override_date;
    }

    const response_user_id = localStorage.getItem("response_user_id") ?? null;
    if (response_user_id) {
      metaData.response_user_id = response_user_id;
    }

    // Add custom values to the metadata
    if (formattedData?.length > 0) {
      metaData.customValues = formattedData;
    }

    if (showContactForm && Object.keys(contactFormData).length > 0) {
      const contactInfo = {
        name: contactFormData.name || "",
        email: contactFormData.email || "",
        phone: contactFormData.phone || "",
        country:
          contactFormData.phoneCountry ||
          getPhoneCountry(contactFormData.phone) ||
          undefined,
        code:
          getPhoneDialCode(
            contactFormData.phone,
            contactFormData.phoneCountry,
          ) || undefined,
        customValues: [],
      };

      if (survey_without_login?.contact_custom_fields?.length > 0) {
        survey_without_login.contact_custom_fields.forEach((field) => {
          if (contactFormData[field.fieldKey]) {
            contactInfo.customValues.push({
              fieldKey: field.fieldKey,
              fieldName: field.fieldName,
              fieldType: field.fieldType,
              value: contactFormData[field.fieldKey],
            });
          }
        });
      }

      metaData.contactInfo = contactInfo;

      if (survey_without_login?.helpdesk_create_ticket) {
        metaData.helpdesk_create_ticket = true;
      }
    }

    // Creating a FormData object for sending the survey response
    const form_data = new FormData();
    form_data.append("metaData", JSON.stringify(metaData));
    form_data.append("jsonData", JSON.stringify(answeresCopy));
    form_data.append("responseData", JSON.stringify(responseData));
    form_data.append("director_message", directorMessage);
    form_data.append("ticketCreatorId", ticketCreatorId);
    form_data.append("surveyTotal", surveyTotal);
    form_data.append("source", source);

    // Add company id to the FormaData
    const companyId = localStorage.getItem("company_id");
    form_data.append("company_id", companyId);
    if (
      localStorage.getItem("tmp_response_id") &&
      localStorage.getItem("tmp_response_id") !== "undefined"
    ) {
      form_data.append(
        "tmp_response_id",
        localStorage.getItem("tmp_response_id"),
      );
    }

    // Adding files to the FormData if any exist
    if (filesArray.length) {
      filesArray.forEach((item) => {
        const key = Object.keys(item)[0];
        const { questionType } = item[key];
        let images = [];

        // Processing image files based on question type
        if (questionType === "file" || questionType === "handwrittenInput") {
          if (item[key]?.value?.length) {
            item[key].value.forEach((img) => images.push(img));
          }
          if (item[key]?.image?.length) {
            item[key].image.forEach((img) => images.push(img));
          }
        } else {
          images = item[key]?.image || [];
        }
        // Appending images to formData
        if (images.length) {
          images.forEach((image) => {
            form_data.append(key, image);
          });
        }
      });
    }

    try {
      /**
       *  DONOT DELETE
       *  This code is to add validation to allow one survey per browser
       */
      // const surveyCookie = cookies.survey;
      // if (surveyCookie?.survey_id !== localStorage.getItem("survey")) {
      // Making an API call to submit the survey answers
      const result = await axiosPostData("survey/answerSurvey", form_data);
      // On successful submission, redirect to thank you page
      if (result) {
        setCookie(
          "survey",
          {
            survey: "submited",
            survey_id: localStorage.getItem("survey") || "",
          },
          { path: "/", maxAge: 86400 },
        );
        // Check if response expiration is enabled
        // Not for a CSAT email: the server allows one answer per email, and
        // this cookie would block the customer's other emails for the survey.
        if (
          survey_without_login?.multipleSubmissionsDisabled &&
          !getCsatToken()
        ) {
          const expirationSeconds = calculateExpirationTime(
            survey_without_login.expirationTimeUnit,
            survey_without_login.expirationDuration,
          );

          // Set cookie with calculated expiration
          setSurveyResponseCookie(
            "survey_response",
            {
              survey: "submited",
              survey_id: localStorage.getItem("survey") || "",
              expires: expirationSeconds,
            },
            {
              path: "/",
              maxAge: expirationSeconds,
            },
          );
        }
        if (surveyWithoutLogin) {
          localStorage.removeItem("location");
          history.push({
            pathname: "/surveyThankYou",
            state: {
              surveyWithoutLogin: true,
              uniqueshortcode: result?.data?.results?.uniqueshortcode || "",
              isAllowGoogleQR: isAllowGoogleQR,
            },
          });
        } else {
          history.push({
            pathname: "/surveyThankYou",
            state: {
              uniqueshortcode: result?.data?.results?.uniqueshortcode || "",
              isAllowGoogleQR: isAllowGoogleQR,
            },
          });
        }
      }
      /**
       *  DONOT DELETE
       *  This code is to add validation to allow one survey per browser
       */
      // } else {
      //   history.push("/sameDaySurvey");
      // }
    } catch (e) {
      // Handling errors during submission
      console.log(e);
      const csatCode = csatErrorCode(e);
      if (csatCode === CSAT_ERROR_CODES.ALREADY_SUBMITTED) {
        // This CSAT email was already answered (another tab, a double tap).
        history.push("/sameDaySurvey");
      } else {
        // Show error toast to user for network/server errors
        toast.error(
          intl.formatMessage({
            id:
              csatCode === CSAT_ERROR_CODES.TOKEN_INVALID
                ? "csat-link-invalid"
                : "network-error-please-try-again",
          }),
        );
      }
    }
    setLoading(false); // Sets loading state to false after function execution
  };

  const [submitSurvey, setSubmitSurvey] = useState(false);

  useEffect(() => {
    if (submitSurvey) {
      submitAnswers();
    }
  }, [submitSurvey]);

  const finishSurvey = (shouldFinish, question) => {
    if (!shouldFinish) {
      return;
    }
    let currentQuestionIndex = "";
    // Finding the index of the current question in the array of all questions
    for (let index = 0; index < allQuestions.length; index++) {
      const element = allQuestions[index]._id === question._id;
      if (element) {
        currentQuestionIndex = index;
      }
    }
    for (
      let index = currentQuestionIndex + 1;
      index < allQuestions.length;
      index++
    ) {
      const questionId = allQuestions[index]._id;
      removeAnswer_({ id: questionId });
    }
    // Set submitSurvey state to true to indicate survey completion
    setSubmitSurvey(true);
  };

  const { getRemainingTime } = useIdleTimer({
    timeout: 1000 * (Number(survey_without_login?.ideal_duration) || 60),
    onIdle: async () => {
      getRemainingTime();
      // This is used to submit the answers when the user is idle for a certain period of time
      submitAnswers("idle");
    },

    debounce: 500,
  });
  const chatContainerRef = useRef(null);

  const scrollToBottom = () => {
    if (chatContainerRef.current) {
      chatContainerRef.current.scrollTop =
        chatContainerRef.current.scrollHeight + 100;
    }
  };
  const [contentCallBack, setContentCallBack] = useState(false);

  useEffect(() => {
    scrollToBottom();
    return () => {
      setContentCallBack(false);
    };
  }, [questionHistory, contentCallBack, questionLoading]);

  const isEditingGridspot =
    Boolean(edit_answer && Object.keys(edit_answer).length) &&
    questionToRender?.questionType === "gridspot";
  const editingGridspotId = isEditingGridspot ? questionToRender._id : null;
  const currentPromptQuestion = allQuestions[currentQuestionIndex];
  const isEditingCurrentGridspotInHistory = Boolean(
    editingGridspotId &&
    editingGridspotId === currentPromptQuestion?._id &&
    questionHistory?.some(
      (chat) =>
        !chat?.fromUser && chat?.question?._id === currentPromptQuestion?._id,
    ),
  );
  const renderGridSpotInput = (question) =>
    question?.questionType === "gridspot" ? (
      <GridSpotType
        survey_theme={survey?.survey_theme}
        question={question}
        finishSurvey={finishSurvey}
        onSend={handleQuestionHistory}
        allQuestionsOriginal={allQuestionsOriginal}
        setAllQuestions={setAllQuestions}
        surveyType={surveyType}
        currentQuestionIndex={currentQuestionIndex}
        allQuestions={allQuestions}
        hideQuestion={(hideIndex, questionID, selectedId) =>
          hideQuestions(hideIndex, questionID, selectedId)
        }
      />
    ) : null;

  return (
    <LoadingOverlay
      active={loading}
      spinner
      className="overflow-hidden"
      styles={{
        content: { height: "100vh", display: "flex", width: "100vw" },
      }}
    >
      {/* Render content only when loading state is false */}
      {!loading ? (
        <div className="mobile-view-rating-app min-h-screen font-sans antialiased text-black bg-gray-100 selection:text-white selection:bg-purple-600">
          <div className="relative max-w-lg min-h-screen mx-auto border-l border-r border-gray-200 questionContainer">
            <div className="sticky top-0 left-0 z-10 w-full px-3 py-3 bg-white border-b border-gray-100 shadow">
              <div className="relative flex items-center justify-center min-h-[32px] mb-2">
                <img
                  className="w-auto h-8 max-w-[55%]"
                  src={logo}
                  alt="first-serve-img"
                />
                {survey_without_login?.allowPartialResponse && (
                  <button
                    type="button"
                    className="btn icon-btn icon-right"
                    style={{
                      position: "absolute",
                      right: 0,
                      top: "50%",
                      transform: "translateY(-50%)",
                      backgroundColor: loading
                        ? "#9CA3AF"
                        : survey?.survey_theme?.primaryColor || "#404040",
                      border: "1px solid",
                      color: "#fff",
                      borderRadius: "1rem",
                      fontSize: "10px",
                      padding: "4px 8px",
                      lineHeight: 1.2,
                      maxWidth: "42%",
                      whiteSpace: "normal",
                      textAlign: "center",
                    }}
                    disabled={loading}
                    onClick={handleSaveAndExit}
                  >
                    {intl.formatMessage({ id: "save-and-exit" })}
                  </button>
                )}
              </div>
              <SupportLang mobile />
            </div>
            <div
              className="space-y-5 whole-page questionview"
              style={{
                padding: "0.6rem",
                paddingBottom: "55px",
                overflowY: "auto",
              }}
              ref={chatContainerRef}
            >
              {/* Render previous answers or questions */}
              {allQuestions[currentQuestionIndex]?.questionType !==
                "director_message" &&
              allQuestions[currentQuestionIndex]?.questionType !==
                "contact_form" &&
              questionHistory?.length
                ? questionHistory?.map((chat, index) =>
                    chat?.fromUser ? (
                      <SingleAnswer
                        answer={chat}
                        key={index}
                        survey_theme={survey?.survey_theme}
                        allQuestions={allQuestions}
                      />
                    ) : (
                      <>
                        <SingleQuestion
                          survey_theme={survey?.survey_theme}
                          question={chat?.question}
                          key={index}
                        />
                        {editingGridspotId &&
                        chat?.question?._id === editingGridspotId
                          ? renderGridSpotInput(chat?.question)
                          : null}
                        {(() => {
                          if (questionToRender?.questionType === "gridspot") {
                            return null;
                          }

                          const selectedValue =
                            answeres[questionToRender?._id]?.value;
                          const options = questionToRender?.options || [];

                          let hasImageRequired = false;

                          if (Array.isArray(selectedValue)) {
                            // ✅ Case 1: Multiple selections — check if any answer value has image_required
                            hasImageRequired = selectedValue.some((val) =>
                              options.some(
                                (opt) => opt._id === val && opt.image_required,
                              ),
                            );
                          } else if (selectedValue) {
                            // ✅ Case 2: Single selection — check if the answer value has image_required
                            const selectedOption = options.find(
                              (opt) => opt._id === selectedValue,
                            );
                            hasImageRequired =
                              selectedOption?.image_required || false;
                          }

                          return hasImageRequired ? (
                            <CommentsAndImage
                              question={questionToRender}
                              onContentCallBack={setContentCallBack}
                              isEdit={true}
                            />
                          ) : null;
                        })()}
                      </>
                    ),
                  )
                : ""}
              {/* Render submit button */}
              {currentQuestionIndex >= allQuestions?.length ? (
                <div className="fixed bottom-0 z-10 w-full max-w-lg mx-auto -translate-x-1/2 left-1/2 answerContainer">
                  <div className="px-2 bg-white border-t border-gray-200">
                    <div className="flex items-center justify-end space-x-3 h-18">
                      <button
                        className="btn icon-btn icon-right"
                        title={intl.formatMessage({ id: "submit" })}
                        style={{
                          backgroundColor: survey?.survey_theme?.primaryColor,
                          border: "1px solid",
                          color: "#fff",
                          borderRadius: "1rem",
                        }}
                        disabled={loading}
                        onClick={submitAnswers}
                      >
                        {intl.formatMessage({ id: "submit" })}
                      </button>
                    </div>
                  </div>
                </div>
              ) : allQuestions[currentQuestionIndex]?.questionType ===
                "director_message" ? (
                // Render director message input section
                <>
                  <ClientConnectDirector
                    clientConnect={currentSurvey.clientConnect}
                    leadershipUser={currentSurvey.leadershipUser}
                    value={directorMessage}
                    onChange={(e) => addDirectorMessage_(e.target.value)}
                    isVisitInformation={currentSurvey?.visit_information}
                    selectedTimeOut={selectedTimeOut}
                    setSelectedTimeOut={(time) => {
                      setSelectedTimeOut(time);
                      // setVisitTimeError(false);
                    }}
                    isSurveyCompetition={currentSurvey?.competitionInformation}
                    contactDetail={contactDetail}
                    contactDetailErrors={contactDetailErrors}
                    updateContactDetails={updateContactDetails}
                    competitionInfoText={
                      currentSurvey?.competition_information_text || ""
                    }
                    customValues={currentSurvey?.customValues}
                    updateCustomValues={updateCustomValues}
                    customValuesErrors={customValuesErrors}
                  />
                  <div className="fixed bottom-0 z-10 w-full max-w-lg mx-auto -translate-x-1/2 left-1/2 answerContainer">
                    <div className="px-2 bg-white border-t border-gray-200">
                      <div className="flex items-center justify-end space-x-3 h-18">
                        <button
                          className="btn icon-btn icon-right"
                          title={intl.formatMessage({
                            id:
                              currentQuestionIndex === allQuestions.length - 1
                                ? "submit"
                                : "next",
                          })}
                          style={{
                            backgroundColor: survey?.survey_theme?.primaryColor,
                            border: "1px solid",
                            color: "#fff",
                            borderRadius: "1rem",
                          }}
                          disabled={loading}
                          onClick={
                            currentQuestionIndex === allQuestions.length - 1
                              ? submitAnswers
                              : () => {
                                  const hasErrors =
                                    validateCompetitionCustomValues();
                                  if (hasErrors) {
                                    return;
                                  }
                                  setCurrentQuestionIndex(
                                    currentQuestionIndex + 1,
                                  );
                                }
                          }
                        >
                          {intl.formatMessage({
                            id:
                              currentQuestionIndex === allQuestions.length - 1
                                ? "submit"
                                : "next",
                          })}
                        </button>
                      </div>
                    </div>
                  </div>
                </>
              ) : questionToRender?.questionType === "contact_form" ? (
                <>
                  <ContactForm
                    contactFormConfig={{
                      contact_info_title: currentSurvey?.contact_info_title,
                      contact_info_description:
                        currentSurvey?.contact_info_description,
                      contact_fields: currentSurvey?.contact_fields,
                      contact_custom_fields:
                        currentSurvey?.contact_custom_fields,
                    }}
                    contactFormData={contactFormData}
                    updateContactFormData={updateContactFormData}
                    contactFormErrors={contactFormErrors}
                  />
                  <div className="fixed bottom-0 z-10 w-full max-w-lg mx-auto -translate-x-1/2 left-1/2 answerContainer">
                    <div className="px-2 bg-white border-t border-gray-200">
                      <div className="flex items-center justify-end space-x-3 h-18">
                        <button
                          className="btn icon-btn icon-right"
                          title={intl.formatMessage({ id: "submit" })}
                          style={{
                            backgroundColor: survey?.survey_theme?.primaryColor,
                            border: "1px solid",
                            color: "#fff",
                            borderRadius: "1rem",
                          }}
                          disabled={loading}
                          onClick={submitAnswers}
                        >
                          {intl.formatMessage({ id: "submit" })}
                        </button>
                      </div>
                    </div>
                  </div>
                </>
              ) : (
                !questionLoading && (
                  // Render current question and related components
                  <>
                    {questionHistory?.some(
                      (chat) =>
                        !chat?.fromUser &&
                        chat?.question?._id === currentPromptQuestion?._id,
                    ) ? null : (
                      <>
                        <SingleQuestion
                          survey_theme={survey?.survey_theme}
                          question={currentPromptQuestion}
                        />
                        {!isEditingCurrentGridspotInHistory
                          ? renderGridSpotInput(currentPromptQuestion)
                          : null}
                        {/* Render comment and image upload section if applicable */}
                        {currentPromptQuestion?.allow_comment ||
                        currentPromptQuestion?.allow_file_upload ? (
                          <CommentsAndImage
                            question={currentPromptQuestion}
                            onContentCallBack={setContentCallBack}
                          />
                        ) : null}
                      </>
                    )}
                  </>
                )
              )}

              {!questionLoading &&
              questionToRender?.questionType === "handwrittenInput" ? (
                <SignatureType
                  survey_theme={survey?.survey_theme}
                  question={questionToRender}
                  onSend={handleQuestionHistory}
                />
              ) : (
                ""
              )}
              {/* Render specific question types based on the question */}
              {!questionLoading &&
              questionToRender?.questionType !== "gridspot" ? (
                <div className="fixed bottom-0 z-10 w-full max-w-lg mx-auto -translate-x-1/2 left-1/2 answerContainer">
                  {questionToRender?.questionType === "text" ? (
                    <TextType
                      survey_theme={survey?.survey_theme}
                      question={questionToRender}
                      onSend={handleQuestionHistory}
                      allQuestions={allQuestions}
                      allQuestionsOriginal={allQuestionsOriginal}
                    />
                  ) : questionToRender?.questionType === "radio" ? (
                    <RadioType
                      survey_theme={survey?.survey_theme}
                      question={questionToRender}
                      finishSurvey={finishSurvey}
                      onSend={handleQuestionHistory}
                      headTonext={(skipIndex, questionId) =>
                        routeToIndex(skipIndex, questionId)
                      }
                      hideQuestion={(hideIndex, questionID, selectedId) =>
                        hideQuestions(hideIndex, questionID, selectedId)
                      }
                      allQuestionsOriginal={allQuestionsOriginal}
                      setAllQuestions={setAllQuestions}
                      surveyType={surveyType}
                      currentQuestionIndex={currentQuestionIndex}
                      allQuestions={allQuestions}
                    />
                  ) : questionToRender?.questionType === "dropdown" ? (
                    <DropdownType
                      survey_theme={survey?.survey_theme}
                      question={questionToRender}
                      onSend={handleQuestionHistory}
                    />
                  ) : questionToRender?.questionType === "employees" ? (
                    <EmployeeType
                      survey_theme={survey?.survey_theme}
                      question={questionToRender}
                      onSend={handleQuestionHistory}
                      loading={empLoading}
                    />
                  ) : ["multiselect", "skills"].includes(
                      questionToRender?.questionType,
                    ) ? (
                    <CheckBoxType
                      survey_theme={survey?.survey_theme}
                      question={questionToRender}
                      onSend={handleQuestionHistory}
                      allQuestionsOriginal={allQuestionsOriginal}
                      setAllQuestions={setAllQuestions}
                      surveyType={surveyType}
                      currentQuestionIndex={currentQuestionIndex}
                      hideQuestion={(hideIndex, questionID, selectedId) =>
                        hideQuestions(hideIndex, questionID, selectedId)
                      }
                      finishSurvey={finishSurvey}
                      allQuestions={allQuestions}
                    />
                  ) : questionToRender?.questionType === "rating" ? (
                    <RatingType
                      survey_theme={survey?.survey_theme}
                      question={questionToRender}
                      finishSurvey={finishSurvey}
                      onSend={handleQuestionHistory}
                      headTonext={(skipIndex, questionId) =>
                        routeToIndex(skipIndex, questionId)
                      }
                      hideQuestion={(hideIndex) => hideQuestions(hideIndex)}
                      allQuestionsOriginal={allQuestionsOriginal}
                      setAllQuestions={setAllQuestions}
                      surveyType={surveyType}
                      currentQuestionIndex={currentQuestionIndex}
                      allQuestions={allQuestions}
                    />
                  ) : questionToRender?.questionType === "sequence" ? (
                    <>
                      <SequenceType
                        survey_theme={survey?.survey_theme}
                        question={questionToRender}
                        onSend={handleQuestionHistory}
                        allQuestionsOriginal={allQuestionsOriginal}
                        setAllQuestions={setAllQuestions}
                        surveyType={surveyType}
                        currentQuestionIndex={currentQuestionIndex}
                        hideQuestion={(hideIndex) => hideQuestions(hideIndex)}
                        finishSurvey={finishSurvey}
                        allQuestions={allQuestions}
                      />
                    </>
                  ) : questionToRender?.questionType === "emoji" ? (
                    <EmojiType
                      survey_theme={survey?.survey_theme}
                      question={questionToRender}
                      onSend={handleQuestionHistory}
                      headTonext={(skipIndex, questionId) =>
                        routeToIndex(skipIndex, questionId)
                      }
                      hideQuestion={(hideIndex) => hideQuestions(hideIndex)}
                      allQuestionsOriginal={allQuestionsOriginal}
                      setAllQuestions={setAllQuestions}
                      surveyType={surveyType}
                      currentQuestionIndex={currentQuestionIndex}
                      allQuestions={allQuestions}
                      finishSurvey={finishSurvey}
                    />
                  ) : questionToRender?.questionType === "file" ? (
                    <FileUploadType
                      survey_theme={survey?.survey_theme}
                      question={questionToRender}
                      onSend={handleQuestionHistory}
                    />
                  ) : questionToRender?.questionType === "star_rating" ? (
                    <StarRatingType
                      survey_theme={survey?.survey_theme}
                      question={questionToRender}
                      onSend={handleQuestionHistory}
                    />
                  ) : questionToRender?.questionType === "number" ? (
                    <NumberType
                      survey_theme={survey?.survey_theme}
                      question={questionToRender}
                      onSend={handleQuestionHistory}
                    />
                  ) : questionToRender?.questionType === "inventory" ? (
                    <InventoryType
                      survey_theme={survey?.survey_theme}
                      question={questionToRender}
                      onSend={handleQuestionHistory}
                    />
                  ) : questionToRender?.questionType === "grid" ? (
                    <GridType
                      survey_theme={survey?.survey_theme}
                      question={questionToRender}
                      onSend={handleQuestionHistory}
                      gridHideQuestions={gridHideQuestions}
                    />
                  ) : (
                    ""
                  )}
                </div>
              ) : null}
            </div>
            {/* Render loading spinner if questions are loading */}
            {questionLoading &&
            allQuestions[currentQuestionIndex]?.questionType !==
              "director_message" &&
            allQuestions[currentQuestionIndex]?.questionType !==
              "contact_form" ? (
              <div
                style={{
                  bottom: "1%",
                  position: "absolute",
                  paddingLeft: "10px",
                }}
              >
                <SyncLoader
                  margin={1}
                  size={10}
                  speedMultiplier={1}
                  color={survey?.survey_theme?.primaryColor}
                />
              </div>
            ) : null}
          </div>
        </div>
      ) : (
        <div className="vw-100 vh-100" />
      )}
      {showErrorPopup?.show && (
        <AutoSubmitErrorPopup
          showErrorPopup={showErrorPopup}
          onClose={() => {
            handleClosePage();
          }}
        />
      )}
    </LoadingOverlay>
  );
}
// Redux mapping function to map state and dispatch to props
const mapStateToProps = (state) => {
  return {
    answeres: state.survey.answeres,
    locations: state.survey.locations,
    survey_without_login: state.survey.survey_without_login,
    survey_theme: state.survey.survey_theme,
    survey: state.survey,
    directorMessage: state.survey.directorMessage,
    contactDetails: state.contactDetails,
    edit_answer: state.survey.edit_answer,
  };
};
// Redux mapping function to map dispatch to props
const mapDispatchToProps = (dispatch) => {
  return {
    addDirectorMessage_: (data) => dispatch(addDirectorMessage(data)),
    removeAnswer_: (data) => dispatch(removeAnswer(data)),
    setSurveyTheme_: (data) => dispatch(setSurveyTheme(data)),
    clearEditAnswer_: () => dispatch(clearEditAnswer()),
  };
};
// Connect the Redux store to the component
export default connect(mapStateToProps, mapDispatchToProps)(Question);
